//import React from "react";
//import ReactDOM from "react-dom";
//import PlayerRanking from "./App";

//ReactDOM.render(
//  <React.StrictMode>
//    <PlayerRanking />
//  </React.StrictMode>,
//  document.getElementById("root")
//);

import React from "react";
import { createRoot } from "react-dom/client";
import PlayerRanking from "./App";

const root = createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PlayerRanking />
  </React.StrictMode>
);
